import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const templateSchema = z.object({
  id: z.number(),
  name: z.string(),
  parameters: z.array(
    z.object({
      id: z.number(),
      name: z.string().optional(),
      types: z.array(z.string()),
      dataTypes: z.string(),
    })
  ),
  createdOn: coercedDate,
});

export type Template = z.infer<typeof templateSchema>;
